import { isEmbed, getEmbedApimKey } from './embed';

export const isApimEnabled = (): boolean =>
  isEmbed() ? true : import.meta.env.VITE_APIM_ENABLED === 'true';

export const getApimSubscriptionKey = (): string | undefined =>
  isEmbed() ? getEmbedApimKey() : undefined;

/** Partners APIM product base URL — used only in partner embed mode. */
const getPartnersApimUrl = (): string | undefined =>
  import.meta.env.VITE_PARTNERS_APIM_URL || undefined;

/** API base URL for first-party requests. */
export const getApiUrl = () => import.meta.env.VITE_API_URL;

/** Auth0 API audience — defaults to the API URL, but can be set independently so
 * the API base can be a tunnel while the audience stays the registered identifier. */
export const getAuth0Audience = () => import.meta.env.VITE_AUTH0_AUDIENCE || getApiUrl();

/** HTTP base URL for the server proxy, direct development API, or partner API. */
export const getApiBaseUrl = (): string => {
  // Partner embed: always route through the partners APIM product using the
  // per-partner key forwarded in the iframe URL.
  if (isEmbed()) {
    const partnersUrl = getPartnersApimUrl();
    const partnerKey = getEmbedApimKey();
    if (!partnersUrl) {
      throw new Error(
        'Embed mode is misconfigured: VITE_PARTNERS_APIM_URL is not set. ' +
          'Set it to the partners APIM product base URL to enable partner embeds.'
      );
    }
    if (!partnerKey) {
      throw new Error(
        'Embed mode requires a partner subscription key. ' +
          'Load the app with ?key=<partner APIM subscription key>.'
      );
    }
    return partnersUrl;
  }

  if (!isApimEnabled()) return getApiUrl();
  return '/backend';
};

export const getAuth0Domain = () => import.meta.env.VITE_AUTH0_DOMAIN;

export const getAuth0ClientId = () => import.meta.env.VITE_AUTH0_CLIENT_ID;

export const getMixpanelToken = () => import.meta.env.VITE_MIXPANEL_TOKEN;

export const getAppUrl = () => import.meta.env.VITE_APP_URL;

export const getMode = () => import.meta.env.MODE;
